
import KycDocumentController from './kyc_document_controller';

export default class extends KycDocumentController {
  static targets = KycDocumentController.targets.concat([
    'fileBack',
    'fileBackName',
    'fileBackInput',
    'choseSingleFile',
    'choseSeparateFiles',
    'singleOrMultipleFilesLabel',
    'driversLicenseNotice',
    'fileInputBlock',
    'backFileLabel',
    'fileState',
  ]);

  initialize() {
    this.fileBackSavedData = { filename: '', file: '', cacheInput: '' };
  }

  connect() {
    super.connect();
    this.saveFileBackState();
    this.toggleFileBackInput();
  }

  // ACTIONS

  toggleFileBackInput() {
    if (this.choseSeparateFilesTarget.checked) {
      this.fileBackTarget.classList.remove('d-none');
      this.fileInputBlockTarget.classList.add('row-cols-md-2');
      this.setFileName(this.fileBackInputTarget, this.fileBackNameTarget, true);
      this.restoreFileBackState();
    } else {
      this.saveFileBackState();
      this.fileBackTarget.classList.add('d-none');
      this.fileInputBlockTarget.classList.remove('row-cols-md-2');
      this.fileBackInputTarget.value = '';
      this.fileBackNameTarget.innerHTML = '';
    }
  }

  toggleDoubleSideLogic() {
    this.toggleFileInputBlock();
    this.toggleSingleOrSeparateFileChoiceButtons();
    this.toggleSingleOrSeparateFileChoice();
    this.toggleFileBackInput();
  }

  changeBackBorderColor(_event) {
    if (this.fileBackInputTarget.value) {
      this.replaceClassByPrefix(this.fileBackTarget, 'border-', 'border-primary');
      if (this.hasFileStateTarget) {
        this.fileStateTarget.classList.add('d-none')
      }
    } else {
      this.replaceClassByPrefix(this.fileBackTarget, 'border-', 'border-gray-300');
      if (this.hasFileStateTarget) {
        this.fileStateTarget.classList.remove('d-none')
      }
    }
  }

  replaceClassByPrefix(el, prefix, newClass) {
    let classes = el.className.split(' ').filter(c => !c.startsWith(prefix));
    el.className = classes.join(' ').trim();
    el.classList.add(newClass);
    return el;
  }

  updateFileBackName(_event) {
    this.setFileName(this.fileBackInputTarget, this.fileBackNameTarget, true);
    this.changeBackBorderColor();
    if (this.fileBackInputTarget.value) {
      this.backFileLabelTarget.classList.add('d-none');
    } else {
      this.backFileLabelTarget.classList.remove('d-none');
    }
  }

  // METHODS

  saveFileBackState() {
    let dt = new DataTransfer();
    // https://stackoverflow.com/questions/5632629/how-to-change-a-file-inputs-filelist-programmatically
    if (this.fileBackInputTarget.files.length == 1) {
      dt.items.add(this.fileBackInputTarget.files[0]);
    }

    this.fileBackSavedData['file'] = dt.files;
    this.fileBackSavedData['filename'] = this.fileBackNameTarget.innerHTML;
  }

  restoreFileBackState() {
    this.fileBackInputTarget.files = this.fileBackSavedData['file'];
    this.fileBackNameTarget.innerHTML = this.fileBackSavedData['filename'];
  }

  toggleSingleOrSeparateFileChoiceButtons() {
    this.singleOrSeparateFileChoiceButtonsTarget.classList.toggle('d-none');
  }
}
